import { putApi, getApi, postApi } from './common/apis';

export default class PartnerOpportunityService {

	async getTermsAndConditionsStatus(payload) {
		var response = await getApi(`v1/vendor-response-screen/${payload.encryptionId}/accept-terms`);
		return response;
	}

	async updateTermsAndConditions(payload) {
		var response = await putApi(`v1/vendor-response-screen/${payload.encryptionId}/accept-terms`, payload);
		return response;
	}

	async getOpportunityDetails(payload) {
		var response = await getApi(`v1/vendor-response-screen/${payload.encryptionId}`);
		return response;
	}

	async downloadAttachment(payload) {
		var response = await getApi(`v1/s3-signed-url?key=${payload.fileName}`);
		return response;
	}

	async participate(payload) {
		var response = await putApi(`v1/vendor-response-screen/${payload.encryptionId}/participation`, payload);
		return response;
	}

	async getPreSignedUrlForAttachment(payload) {
		var response = await getApi(`v1/upload-file-for-questions?key=${payload.fileName}`);
		return response;
	}

	async submitOpportunityResponse(payload) {
		var response = await postApi(`v1/vendor-response/${payload.encryptionId}`, payload.submissionData);
		return response;
	}

	async retractResponse(payload) {
		var response = await putApi(`v1/vendor-response-screen/${payload.encryptionId}/retract`, payload);
		return response;
	}

	async decline(payload) {
		var response = await putApi(`v1/vendor-response-screen/${payload.encryptionId}/decline`, payload);
		return response;
	}

	async saveAsDraft(payload) {
		var response = await postApi(`v1/vendor-response/${payload.encryptionId}/draft`, payload.submissionData);
		return response;
	}

	async emailResponseExcel(payload) {
		var response = await postApi(`v1/vendor-response/${payload.encryptionId}/email-excel`, {});
		return response;
	}

}
